import {
	TEAMS_FAILURE,
	TEAMS_SUCCESS,
	TEAMS_LOADING,
	POST_LOADING,
	POST_SUCCESS,
	POST_FAILURE,
	POSTS_LOADING,
	POSTS_SUCCESS,
	POSTS_FAILURE,
	SUBPOSTS_LOADING,
	SUBPOSTS_SUCCESS,
	SUBPOSTS_FAILURE,
	CREATE_TEAM,
	CREATE_TEAM_SUCCESS,
	CREATE_TEAM_FAILURE,
	SENDING_TOKENS,
	SEND_TOKENS_SUCCESS,
	SEND_TOKENS_FAILURE,
	SENDING_SUBPOST_TOKENS,
	SEND_SUBPOST_TOKENS_SUCCESS,
	SEND_SUBPOST_TOKENS_FAILURE,
	RESET_SEND_TOKENS_SUCCESS,
	LIKE_POST,
	LIKE_POST_SUCCESS,
	LIKE_POST_FAILURE,
	LIKE_SUBPOST,
	LIKE_SUBPOST_SUCCESS,
	LIKE_SUBPOST_FAILURE,
	ADD_TEAM_MEMBERS,
	ADD_TEAM_MEMBERS_FAILURE,
	ADD_TEAM_MEMBERS_SUCCESS,
	RESET_ADD_TEAM_MEMBERS_COMPLETE,
	EDIT_TEAM,
	EDIT_TEAM_SUCCESS,
	EDIT_TEAM_FAILURE,
	DELETE_TEAM,
	DELETE_TEAM_FAILURE,
	DELETE_TEAM_SUCCESS,
	RESET_DELETE_TEAM_SUCCESS,
	RESET_EDIT_TEAM_SUCCESS,
	RESET_CREATE_TEAM_SUCCESS,
	START_SEASON,
	START_SEASON_SUCCESS,
	START_SEASON_FAILURE,
	RESET_START_SEASON_SUCCESS,
	END_SEASON,
	END_SEASON_SUCCESS,
	END_SEASON_FAILURE,
	RESET_END_SEASON_SUCCESS,
	UPDATE_SEASON,
	UPDATE_SEASON_SUCCESS,
	UPDATE_SEASON_FAILURE,
	RESET_UPDATE_SEASON_SUCCESS,
	DELETE_POST_SUCCESS,
	DELETING_POST,
	DELETE_POST_FAILURE,
	RESET_DELETE_POST_SUCCESS,
	TEAM_USER_STATS_LOADING,
	TEAM_USER_STATS_SUCCESS,
	TEAM_USER_STATS_FAILURE,
	SETUP_TEAMHOME_TOUR,
	CLEANUP_TEAMHOME_TOUR,
	SENDING_SHOUT_OUT,
	SENDING_SHOUT_OUT_SUCCESS,
	RESET_SENDING_SHOUT_OUT_SUCCESS,
	SENDING_SHOUT_OUT_FAILURE,
	PAGINATED_POSTS_LOADING,
	PAGINATED_POSTS_SUCCESS,
	PAGINATED_POSTS_FAILURE,
	UPDATE_SELECTED_TEAM,
	DELETE_SUBPOST_SUCCESS,
	DELETING_SUBPOST,
	DELETE_SUBPOST_FAILURE,
	RESET_DELETE_SUBPOST_SUCCESS,
} from 'redux/reduxConstants';
import { Post } from 'redux/models/post';
import { cloneDeep } from 'lodash';
import { Subpost } from 'redux/models/subpost';
import { TeamStats } from 'redux/models/stat';

interface TeamState {
	loading: boolean;
	creatingTeam: boolean;
	creatingTeamSuccess: boolean;
	editingTeam: boolean;
	editingTeamSuccess: boolean;
	deletingTeam: boolean;
	deletingTeamSuccess: boolean;
	sendingTokens: boolean;
	subpostsLoading: boolean;
	addingTeamMembers: boolean;
	addMembersComplete: boolean;
	sendingTokensSuccess: boolean | undefined;
	startingSeason: boolean;
	startingSeasonSuccess: boolean;
	endingSeason: boolean;
	endingSeasonSuccess: boolean;
	updatingSeason: boolean;
	updatingSeasonSuccess: boolean;
	currentPost: Post | undefined;
	deletingPost: boolean;
	deletePostSuccess: boolean;
	deletingSubpost: boolean;
	deleteSubpostSuccess: boolean;
	statsLoading: boolean;
	sendingShoutOut: boolean;
	sendingShoutOutSuccess: boolean;
	posts: Post[];
	paginatedPostsLoading: boolean;
	allPostsLoaded: boolean;
	continuationToken: any;
	stats: TeamStats | null;
	error: string;
}

const teamState: TeamState = {
	loading: false,
	creatingTeam: false,
	creatingTeamSuccess: false,
	editingTeam: false,
	editingTeamSuccess: false,
	deletingTeam: false,
	deletingTeamSuccess: false,
	sendingTokens: false,
	addingTeamMembers: false,
	addMembersComplete: false,
	sendingTokensSuccess: undefined,
	subpostsLoading: false,
	startingSeason: false,
	startingSeasonSuccess: false,
	endingSeason: false,
	endingSeasonSuccess: false,
	updatingSeason: false,
	updatingSeasonSuccess: false,
	currentPost: undefined,
	deletingPost: false,
	deletePostSuccess: false,
	deletingSubpost: false,
	deleteSubpostSuccess: false,
	statsLoading: false,
	sendingShoutOut: false,
	sendingShoutOutSuccess: false,
	posts: [],
	paginatedPostsLoading: false,
	allPostsLoaded: false,
	continuationToken: null,
	stats: null,
	error: '',
};

const teams = (state = teamState, action: any) => {
	switch (action.type) {
		case TEAMS_LOADING:
			let teamsState = { ...state };

			teamsState.loading = true;
			return teamsState;
		case TEAMS_SUCCESS:
			let teamsSuccessState = { ...state };

			teamsSuccessState.loading = false;
			return teamsSuccessState;
		case TEAMS_FAILURE:
			let teamsFailureState = { ...state };

			teamsFailureState.loading = false;
			teamsFailureState.error = action.error;
			return teamsFailureState;
		case POST_LOADING:
			let postsState = { ...state };

			postsState.loading = true;
			return postsState;

		case POST_SUCCESS:
			let postSuccessState = { ...state };

			postSuccessState.loading = false;
			postSuccessState.currentPost = action.post;
			return postSuccessState;
		case POST_FAILURE:
			let postFailureState = { ...state };

			postFailureState.loading = false;
			postFailureState.error = action.error;
			return postFailureState;

		case POSTS_LOADING:
			let postState = { ...state };

			postState.loading = true;
			return postState;

		case POSTS_SUCCESS:
			let postsSuccessState = { ...state };

			postsSuccessState.loading = false;
			postsSuccessState.posts = action.posts.map((post: Post) => ({ ...post, showSubposts: false, subpostsLoading: false }));
			return postsSuccessState;
		case POSTS_FAILURE:
			let postsFailureState = { ...state };

			postsFailureState.loading = false;
			postsFailureState.error = action.error;
			return postsFailureState;

		case PAGINATED_POSTS_LOADING:
			let paginatedPostsState = { ...state };

			if (paginatedPostsState.posts?.length > 0) {
				paginatedPostsState.paginatedPostsLoading = true;
			} else {
				paginatedPostsState.loading = true;
			}
			return paginatedPostsState;
		case PAGINATED_POSTS_SUCCESS:
			let paginatedPostsSuccessState = { ...state };

			paginatedPostsSuccessState.paginatedPostsLoading = false;
			paginatedPostsSuccessState.loading = false;
			let additionalPaginatedPosts = action.posts.map((post: Post) => ({ ...post, showSubposts: false, subpostsLoading: false }));
			paginatedPostsSuccessState.posts = [...paginatedPostsSuccessState.posts, ...additionalPaginatedPosts];
			paginatedPostsSuccessState.continuationToken = action.continuationToken;
			if (!action.continuationToken) paginatedPostsSuccessState.allPostsLoaded = true;
			return paginatedPostsSuccessState;
		case PAGINATED_POSTS_FAILURE:
			let paginatedPostsFailureState = { ...state };

			paginatedPostsFailureState.paginatedPostsLoading = false;
			paginatedPostsFailureState.loading = false;
			paginatedPostsFailureState.error = action.error;
			return paginatedPostsFailureState;

		case UPDATE_SELECTED_TEAM:
			let updateSelectedTeamState = { ...state };
			updateSelectedTeamState.posts = [];
			updateSelectedTeamState.continuationToken = false;
			updateSelectedTeamState.allPostsLoaded = false;
			return updateSelectedTeamState;

		case SUBPOSTS_LOADING:
			let subpostsState = { ...state };
			subpostsState.subpostsLoading = true;
			let subpostsStatePosts = subpostsState.posts.map((post: Post) => {
				if (post.postId === action.postId) {
					return { ...post };
				}
				return { ...post };
			});

			subpostsState.posts = subpostsStatePosts;
			return subpostsState;

		case SUBPOSTS_SUCCESS:
			let subpostsSuccessState = { ...state };
			subpostsSuccessState.subpostsLoading = false;
			let updatedPosts = subpostsSuccessState.posts.map((post: Post) => {
				if (post.postId === action.postId) {
					return { ...post, subposts: action.subposts.reverse() };
				}
				return { ...post };
			});
			subpostsSuccessState.loading = false;
			subpostsSuccessState.posts = updatedPosts;
			return subpostsSuccessState;

		case SUBPOSTS_FAILURE:
			let subpostsFailureState = { ...state };
			subpostsFailureState.subpostsLoading = false;
			subpostsFailureState.loading = false;
			subpostsFailureState.error = action.error;
			return subpostsFailureState;

		case CREATE_TEAM:
			let createTeamLoadingState = { ...state };

			createTeamLoadingState.creatingTeam = true;
			return createTeamLoadingState;
		case CREATE_TEAM_SUCCESS:
			let createTeamSuccessState = { ...state };

			createTeamSuccessState.creatingTeam = false;
			createTeamSuccessState.creatingTeamSuccess = true;
			return createTeamSuccessState;
		case CREATE_TEAM_FAILURE:
			let createTeamFailuresState = { ...state };

			createTeamFailuresState.creatingTeam = false;
			createTeamFailuresState.creatingTeamSuccess = false;
			createTeamFailuresState.error = action.error;
			return createTeamFailuresState;

		case SENDING_TOKENS:
			let sendingTokensState = { ...state };
			sendingTokensState.sendingTokens = true;
			sendingTokensState.sendingTokensSuccess = undefined;

			return sendingTokensState;

		case SEND_TOKENS_SUCCESS:
			let sendTokensSuccessState = { ...state };
			sendTokensSuccessState.sendingTokens = false;
			sendTokensSuccessState.sendingTokensSuccess = true;

			let newPosts = cloneDeep(sendTokensSuccessState.posts);
			newPosts.splice(0, 0, action.post);
			sendTokensSuccessState.posts = newPosts;

			return sendTokensSuccessState;
		case SEND_TOKENS_FAILURE:
			let sendTokensFailureState = { ...state };
			sendTokensFailureState.sendingTokensSuccess = false;
			sendTokensFailureState.sendingTokens = false;
			sendTokensFailureState.error = action.error;

			return sendTokensFailureState;
		case RESET_SEND_TOKENS_SUCCESS:
			let resetSendTokensSuccess = { ...state };
			resetSendTokensSuccess.sendingTokensSuccess = undefined;

			return resetSendTokensSuccess;

		case SENDING_SUBPOST_TOKENS:
			let sendingSubpostTokensState = { ...state };
			sendingSubpostTokensState.sendingTokens = true;
			sendingSubpostTokensState.sendingTokensSuccess = undefined;

			return sendingSubpostTokensState;

		case SEND_SUBPOST_TOKENS_SUCCESS:
			let sendSubpostTokensSuccessState = { ...state };
			sendSubpostTokensSuccessState.sendingTokens = false;
			sendSubpostTokensSuccessState.sendingTokensSuccess = true;

			let updatedPostsWithNewSubpost: Post[] = sendSubpostTokensSuccessState.posts.map((post: Post) => {
				if (post.postId === action.subpost.postId) {
					if (post.subposts === undefined) post.subposts = [];
					return { ...post, subpostCount: post.subpostCount + 1, subposts: [...post.subposts, action.subpost] };
				}
				return { ...post };
			});
			sendSubpostTokensSuccessState.posts = updatedPostsWithNewSubpost;

			return sendSubpostTokensSuccessState;
		case SEND_SUBPOST_TOKENS_FAILURE:
			let sendSubpostTokensFailureState = { ...state };
			sendSubpostTokensFailureState.sendingTokensSuccess = false;
			sendSubpostTokensFailureState.sendingTokens = false;
			sendSubpostTokensFailureState.error = action.error;

			return sendSubpostTokensFailureState;

		case LIKE_POST:
			let likePostState = { ...state };

			return likePostState;

		case LIKE_POST_SUCCESS:
			let likePostSuccessState = { ...state };

			const updatedLikePostSuccessPosts = likePostSuccessState.posts.map((post: Post) => {
				if (post.postId === action.post.postId) return { ...post, likes: action.post.likes };
				else return { ...post };
			});

			likePostSuccessState.posts = updatedLikePostSuccessPosts;
			return likePostSuccessState;

		case LIKE_POST_FAILURE:
			let likePostFailureState = { ...state };
			likePostFailureState.error = action.error;

			return likePostFailureState;

		case LIKE_SUBPOST:
			let likeSubpostState = { ...state };

			return likeSubpostState;

		case LIKE_SUBPOST_SUCCESS:
			let likeSubpostSuccessState = { ...state };

			const updatedLikeSubpostSuccessPosts = likeSubpostSuccessState.posts.map((post: Post) => {
				if (post.postId === action.subpost.postId) {
					const subposts = post.subposts.map((subpost: Subpost) => {
						if (subpost.subpostId === action.subpost.subpostId) return { ...action.subpost };
						else return { ...subpost };
					});
					return { ...post, subposts: subposts };
				} else return { ...post };
			});

			likeSubpostSuccessState.posts = updatedLikeSubpostSuccessPosts;
			return likeSubpostSuccessState;

		case LIKE_SUBPOST_FAILURE:
			let likeSubpostFailureState = { ...state };
			likeSubpostFailureState.error = action.error;

			return likeSubpostFailureState;

		case ADD_TEAM_MEMBERS:
			let addTeamMembersState = { ...state };
			addTeamMembersState.addingTeamMembers = true;
			addTeamMembersState.addMembersComplete = false;

			return addTeamMembersState;

		case ADD_TEAM_MEMBERS_SUCCESS:
			let addTeamMembersSuccessState = { ...state };
			addTeamMembersSuccessState.addingTeamMembers = false;
			addTeamMembersSuccessState.addMembersComplete = true;
			addTeamMembersSuccessState.error = '';

			return addTeamMembersSuccessState;

		case ADD_TEAM_MEMBERS_FAILURE:
			let addTeamMembersFailureState = { ...state };
			addTeamMembersFailureState.addingTeamMembers = false;
			addTeamMembersFailureState.addMembersComplete = true;
			addTeamMembersFailureState.error = action.error;

			return addTeamMembersFailureState;
		case RESET_ADD_TEAM_MEMBERS_COMPLETE:
			let resetAddTeamMemberCompleteState = { ...state };
			resetAddTeamMemberCompleteState.addMembersComplete = false;
			resetAddTeamMemberCompleteState.addingTeamMembers = false;

			return resetAddTeamMemberCompleteState;

		case EDIT_TEAM:
			let editTeamLoadingState = { ...state };
			editTeamLoadingState.editingTeamSuccess = false;
			editTeamLoadingState.editingTeam = true;
			return editTeamLoadingState;
		case EDIT_TEAM_SUCCESS:
			let editTeamSuccess = { ...state };
			editTeamSuccess.editingTeamSuccess = true;
			editTeamSuccess.editingTeam = false;
			return editTeamSuccess;
		case EDIT_TEAM_FAILURE:
			let editTeamFailuresState = { ...state };

			editTeamFailuresState.editingTeam = false;
			editTeamFailuresState.error = action.error;
			return editTeamFailuresState;

		case DELETE_TEAM:
			let deleteTeamState = { ...state };
			deleteTeamState.deletingTeam = true;
			return deleteTeamState;

		// unique case where this action is in the team reducer but also needs to modify this reducer as well
		// its in both so both state will be modified
		case DELETE_TEAM_SUCCESS:
			let deleteTeamSuccessState = { ...state };
			deleteTeamSuccessState.deletingTeam = false;
			deleteTeamSuccessState.deletingTeamSuccess = true;
			return deleteTeamSuccessState;

		case DELETE_TEAM_FAILURE:
			let deleteTeamFailureState = { ...state };
			deleteTeamFailureState.deletingTeam = false;
			deleteTeamFailureState.deletingTeamSuccess = false;
			deleteTeamFailureState.error = action.error;
			return deleteTeamFailureState;

		case RESET_DELETE_TEAM_SUCCESS:
			let resetDeleteTeamSuccessState = { ...state };
			resetDeleteTeamSuccessState.deletingTeamSuccess = false;
			return resetDeleteTeamSuccessState;

		case RESET_CREATE_TEAM_SUCCESS:
			let resetCreateTeamSuccessState = { ...state };
			resetCreateTeamSuccessState.creatingTeamSuccess = false;
			return resetCreateTeamSuccessState;

		case RESET_EDIT_TEAM_SUCCESS:
			let resetEditTeamSuccessState = { ...state };
			resetEditTeamSuccessState.editingTeamSuccess = false;
			return resetEditTeamSuccessState;

		case START_SEASON:
			let startSeasonState = { ...state };
			startSeasonState.startingSeason = true;
			return startSeasonState;

		// unique case where this action is in the team reducer but also needs to modify this reducer as well
		// its in both so both state will be modified
		case START_SEASON_SUCCESS:
			let startSeasonSuccessState = { ...state };
			startSeasonSuccessState.startingSeason = false;
			startSeasonSuccessState.startingSeasonSuccess = true;
			return startSeasonSuccessState;

		case START_SEASON_FAILURE:
			let startSeasonFailureState = { ...state };
			startSeasonFailureState.startingSeason = false;
			startSeasonFailureState.error = action.error;
			return startSeasonFailureState;

		case RESET_START_SEASON_SUCCESS:
			let resetStartSeasonSuccessState = { ...state };
			resetStartSeasonSuccessState.startingSeasonSuccess = false;
			return resetStartSeasonSuccessState;

		// unique case where this action is in the team reducer but also needs to modify this reducer as well
		// its in both so both state will be modified
		case END_SEASON:
			let endSeasonState = { ...state };
			endSeasonState.endingSeason = true;
			return endSeasonState;

		// unique case where this action is in the team reducer but also needs to modify this reducer as well
		// its in both so both state will be modified
		case END_SEASON_SUCCESS:
			let endSeasonSuccessState = { ...state };
			endSeasonSuccessState.endingSeason = false;
			endSeasonSuccessState.endingSeasonSuccess = true;
			return endSeasonSuccessState;

		case END_SEASON_FAILURE:
			let endSeasonFailureState = { ...state };
			endSeasonFailureState.endingSeason = false;
			endSeasonFailureState.error = action.error;
			return endSeasonFailureState;

		case RESET_END_SEASON_SUCCESS:
			let resetEndSeasonSuccessState = { ...state };
			resetEndSeasonSuccessState.endingSeasonSuccess = false;
			return resetEndSeasonSuccessState;

		case UPDATE_SEASON:
			let updateSeasonState = { ...state };
			updateSeasonState.updatingSeason = true;
			return updateSeasonState;

		// unique case where this action is in the team reducer but also needs to modify this reducer as well
		// its in both so both state will be modified
		case UPDATE_SEASON_SUCCESS:
			let updateSeasonSuccessState = { ...state };
			updateSeasonSuccessState.updatingSeason = false;
			updateSeasonSuccessState.updatingSeasonSuccess = true;

			return updateSeasonSuccessState;

		case UPDATE_SEASON_FAILURE:
			let updateSeasonFailureState = { ...state };
			updateSeasonFailureState.updatingSeason = false;
			updateSeasonFailureState.error = action.error;

			return updateSeasonFailureState;

		// unique case where this action is in the team reducer but also needs to modify this reducer as well
		// its in both so both state will be modified
		case RESET_UPDATE_SEASON_SUCCESS:
			let resetUpdateSeasonSuccessState = { ...state };
			resetUpdateSeasonSuccessState.updatingSeasonSuccess = false;
			return resetUpdateSeasonSuccessState;

		case DELETING_POST:
			let deletingPostState = { ...state };
			deletingPostState.deletingPost = true;

			return deletingPostState;

		case DELETE_POST_SUCCESS:
			let deletePostSuccessState = { ...state };
			deletePostSuccessState.deletingPost = false;
			deletePostSuccessState.deletePostSuccess = true;
			let postsUpdatedForDelete = [];
			// I know this is a bit strange. Hear me out.
			// The API for deleting a post has two different methods for deleting.
			// 1. We can delete the post completely (which is what we currently have enabled)
			// 2. Or we can redact the post, where we don't really delete it, we just clear the contents
			//    and leave a post item that says [this post has been deleted]
			// If we 'delete' the deletedPost object comes back as '', but if we redact (in the future)
			// the deletedPost object comes back as an actual post object with a 'redactedPost' post type.
			if (action.deletedPost === '') {
				postsUpdatedForDelete = deletePostSuccessState.posts.filter(post => post.postId !== action.originalPost.postId);
			} else {
				postsUpdatedForDelete = deletePostSuccessState.posts.map(post => {
					if (post.postId === action.originalPost.postId) {
						return action.deletedPost;
					}

					return post;
				});
			}

			deletePostSuccessState.posts = postsUpdatedForDelete;
			return deletePostSuccessState;

		case DELETE_POST_FAILURE:
			let deletePostFailureState = { ...state };
			deletePostFailureState.deletingPost = false;
			deletePostFailureState.error = action.error;

			return deletePostFailureState;

		case RESET_DELETE_POST_SUCCESS:
			let resetDeletePostSuccess = { ...state };
			resetDeletePostSuccess.deletePostSuccess = false;

			return resetDeletePostSuccess;

		case DELETING_SUBPOST:
			let deletingSubpostState = { ...state };
			deletingSubpostState.deletingSubpost = true;

			return deletingSubpostState;

		case DELETE_SUBPOST_SUCCESS:
			let deleteSubpostSuccessState = { ...state };
			deleteSubpostSuccessState.deletingSubpost = false;
			deleteSubpostSuccessState.deleteSubpostSuccess = true;

			let postsUpdateAfterSubpostDelete = deleteSubpostSuccessState.posts.map(post => {
				if (post.postId === action.originalSubpost.postId) {
					post.subposts = post.subposts.filter(subpost => subpost.subpostId !== action.originalSubpost.subpostId);
					post.subpostCount--;
				}
				return post;
			});

			deleteSubpostSuccessState.posts = postsUpdateAfterSubpostDelete;
			return deleteSubpostSuccessState;

		case DELETE_SUBPOST_FAILURE:
			let deleteSubpostFailureState = { ...state };
			deleteSubpostFailureState.deletingSubpost = false;
			deleteSubpostFailureState.error = action.error;

			return deleteSubpostFailureState;

		case RESET_DELETE_SUBPOST_SUCCESS:
			let resetDeleteSubpostSuccess = { ...state };
			resetDeleteSubpostSuccess.deleteSubpostSuccess = false;

			return resetDeleteSubpostSuccess;

		case TEAM_USER_STATS_LOADING:
			let teamUserStatsState = { ...state };

			teamUserStatsState.statsLoading = true;
			return teamUserStatsState;
		case TEAM_USER_STATS_SUCCESS:
			let teamUserStatsSuccessState = { ...state };

			teamUserStatsSuccessState.statsLoading = false;
			teamUserStatsSuccessState.stats = action.stats;
			return teamUserStatsSuccessState;
		case TEAM_USER_STATS_FAILURE:
			let teamUserStatsFailureState = { ...state };

			teamUserStatsFailureState.statsLoading = false;
			teamUserStatsFailureState.error = action.error;
			return teamUserStatsFailureState;

		case SETUP_TEAMHOME_TOUR:
			let setupTeamHomeTourState = { ...state };
			setupTeamHomeTourState.posts = [
				{
					authorEmail: 'tour@tokens.com',
					authorId: 'Tourin',
					authorName: 'ToA Tour',
					comment: 'Welcome to ToA!',
					createdOn: new Date(),
					likes: [],
					postId: '123',
					subpostCount: 0,
					subposts: [],
					teamId: '',
					timestamp: new Date(),
					tokenTotal: 5,
					tokens: 5,
					users: [{ name: action.userName, id: '123' }],
					refType: 'post',
				},
				...setupTeamHomeTourState.posts,
			];
			return setupTeamHomeTourState;

		case CLEANUP_TEAMHOME_TOUR:
			let cleanupTeamHomeTourState = { ...state };
			const cleanedPosts = [...cleanupTeamHomeTourState.posts];

			cleanedPosts.shift();
			cleanupTeamHomeTourState.posts = cleanedPosts;
			return cleanupTeamHomeTourState;
		case SENDING_SHOUT_OUT:
			let sendingShoutOutState = { ...state };
			sendingShoutOutState.sendingShoutOut = true;
			return sendingShoutOutState;

		case SENDING_SHOUT_OUT_SUCCESS:
			let sendingShoutOutSuccessState = { ...state };

			if (action.selectedTeamId) {
				const newShoutOutPost = action.posts.find((p: Post) => p.teamId === action.selectedTeamId);
				if (newShoutOutPost) {
					const clonedPosts = cloneDeep(sendingShoutOutSuccessState.posts);
					clonedPosts.splice(0, 0, newShoutOutPost);
					sendingShoutOutSuccessState.posts = clonedPosts;
				}
			}

			sendingShoutOutSuccessState.sendingShoutOut = false;
			sendingShoutOutSuccessState.sendingShoutOutSuccess = true;
			return sendingShoutOutSuccessState;

		case SENDING_SHOUT_OUT_FAILURE:
			let sendingShoutOutFailureState = { ...state };
			sendingShoutOutFailureState.sendingShoutOut = false;
			sendingShoutOutFailureState.error = action.error;
			return sendingShoutOutFailureState;

		case RESET_SENDING_SHOUT_OUT_SUCCESS:
			let resetSendingShoutOutSuccessState = { ...state };
			resetSendingShoutOutSuccessState.sendingShoutOutSuccess = false;
			return resetSendingShoutOutSuccessState;

		default:
			return state;
	}
};

export default teams;
